import { MBO_SIGNIN_RETURN_PATH } from 'app/shared/consts/mbo-destinations';

/**
 * Handles the sign-in window coming back to us.
 *
 * Mindbody redirects the sign-in window to `embedded_url` once the user authenticates. That
 * lands on our origin with no launch params, so booting the app there would render the error
 * page inside the popup — which is exactly what it did before this existed. We point
 * `embedded_url` at a path nothing else serves and close the window on arrival instead;
 * `useMboWidgetModal` is watching for that close and puts the user back into the cart.
 *
 * Call before React mounts. Returns true when this document is a returning sign-in window and
 * the app should NOT boot.
 */
export const closeSigninReturn = (): boolean => {
  if (window.location.pathname !== MBO_SIGNIN_RETURN_PATH) {
    return false;
  }

  window.close();

  return true;
};
